import React from 'react';
import {Grid} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {convertValueToDollar} from 'common/utils';
import {formatDollarOrEmptyString} from 'common/utils';

export const BudgetSummaryBySubrecipientTable = (props) => {
  const {
    subOrgs,
    selectedColumn,
    sortDirection,
    setSelectedColumnProp,
    setSortDirectionProp,
  } = props;

  const handleColumnClick = (columnName) => {
    let direction = sortDirection == 'ASC' ? 'DESC' : 'ASC';
    setSelectedColumnProp(columnName);
    setSortDirectionProp(direction);
  };
  const getClassName = (columnName) =>
    `sorted${
      selectedColumn == columnName
        ? sortDirection == 'ASC'
          ? ' ascending'
          : ' descending'
        : ''
    }`;

  const renderContents = () => {
    return (
      <Grid key={'subOrgsGrid'} doubling stackable reversed="mobile" padded="vertically">
        <Grid.Column className="visible-overflow">
          <FemaGoTable
            summary={'Budget summary by subrecipient'}
            type="static"
            columns="3"
            className="sortable"
          >
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                <FemaGoTable.HeaderCell
                  title="Subrecipient"
                  onClick={() => handleColumnClick('subrecipient')}
                  className={getClassName('subrecipient')}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      handleColumnClick('subrecipient');
                    }
                  }}
                >
                  Subrecipient
                </FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell
                  title="Management and Administration Costs"
                  onClick={() => handleColumnClick('maCosts')}
                  className={getClassName('maCosts')}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      handleColumnClick('maCosts');
                    }
                  }}
                >
                  Management and Administration Costs
                </FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell
                  title="Subrecipient Total Costs"
                  onClick={() => handleColumnClick('subRecipTotalCosts')}
                  className={getClassName('subRecipTotalCosts')}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      handleColumnClick('subRecipTotalCosts');
                    }
                  }}
                >
                  Subrecipient Total Costs
                </FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(subOrgs, (subOrg) => {
                let showError = false;
                let errorMessages = [];
                return (
                  <FemaGoTable.Row
                    key={`${subOrg.organizationId}`}
                    errorMessages={errorMessages}
                    displayError={showError}
                  >
                    <FemaGoTable.TextCell>
                      {_.get(subOrg, 'displayName')}{' '}
                      <i>
                        (Maximum allowable management cost:{' '}
                        {convertValueToDollar(
                          _.get(subOrg, 'subOrgMaxAllowableMgmtCosts')
                        )}
                        )
                      </i>
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {formatDollarOrEmptyString(_.get(subOrg, 'subOrgMACosts'))}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {formatDollarOrEmptyString(_.get(subOrg, 'subOrgTotalCosts'))}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
        </Grid.Column>
      </Grid>
    );
  };

  return <>{renderContents()}</>;
};

export default connectDynamic(BudgetSummaryBySubrecipientTable);
